import { addBillsSaga } from "./addBills/saga";
import { updateBillsSaga } from "./updateBills/saga";
import { deleteBillsSaga } from "./deleteBills/saga";
import  getPeritajeSaga from "./getPeritaje/saga";
import { takeEvery  } from "redux-saga/effects";
import { getSaleSaga } from "./getSale/saga";
import getCotizacionSaga from "./getCotizacion/saga";
import calculateRemainingSaga from "./calculateRemaining/saga";
import { retryOfferDMSSaga } from "./retryOfferDMS/saga";
import { reEnteredVehicleSaga } from 'gestion-operativa/redux/reEnteredVehicles/saga'

import {
    GESTION_OPERATIVA_ADD_BILLS_BEGIN,
    GESTION_OPERATIVA_UPDATE_BILLS_BEGIN,
    GESTION_OPERATIVA_DELETE_BILLS_BEGIN,
    GESTION_OPERATIVA_GET_PERITAJE,
    GESTION_OPERATIVA_GET_SALE,
    GESTION_OPERATIVA_GET_SALE_SUCCESS,
    GESTION_OPERATIVA_GET_COTIZACION,
    GESTION_OPERATIVA_REMOVE_USADO_A_ENTREGAR,
    GESTION_OPERATIVA_SET_BON_ESPECIAL_USADO,
    GESTION_OPERATIVA_GET_DESCUENTO,
    GESTION_OPERATIVA_SET_BON_ESPECIAL,
    GESTION_OPERATIVA_UPDATE_TAKING_CARS_SUCCESS,
    GESTION_OPERATIVA_SET_USED_TAKE_AMOUNT_USADO,
    GESTION_OPERATIVA_SELECT_STOCK,
    GESTION_OPERATIVA_RETRY_OFFER_BEGIN,
    GESTION_OPERATIVA_RE_ENTERED_VEHICLE_BEGIN
} from './constants'

// Watchers
export default function* gestionOperativa() {
    // Acá van todas las sagas del módulo Gestion Operativa
    yield takeEvery(GESTION_OPERATIVA_ADD_BILLS_BEGIN, addBillsSaga);
    yield takeEvery(GESTION_OPERATIVA_UPDATE_BILLS_BEGIN, updateBillsSaga);
    yield takeEvery(GESTION_OPERATIVA_DELETE_BILLS_BEGIN, deleteBillsSaga);
    yield takeEvery(GESTION_OPERATIVA_GET_PERITAJE, getPeritajeSaga);
    yield takeEvery(GESTION_OPERATIVA_GET_SALE, getSaleSaga);
    yield takeEvery(GESTION_OPERATIVA_GET_SALE_SUCCESS, calculateRemainingSaga);
    yield takeEvery(GESTION_OPERATIVA_GET_COTIZACION, getCotizacionSaga);
    yield takeEvery(GESTION_OPERATIVA_REMOVE_USADO_A_ENTREGAR, calculateRemainingSaga);
    yield takeEvery(GESTION_OPERATIVA_SET_BON_ESPECIAL, calculateRemainingSaga);        
    yield takeEvery(GESTION_OPERATIVA_SET_BON_ESPECIAL_USADO, calculateRemainingSaga);
    yield takeEvery(GESTION_OPERATIVA_GET_DESCUENTO, calculateRemainingSaga);
    yield takeEvery(GESTION_OPERATIVA_UPDATE_TAKING_CARS_SUCCESS, calculateRemainingSaga);
    yield takeEvery(GESTION_OPERATIVA_SET_USED_TAKE_AMOUNT_USADO, calculateRemainingSaga);
    yield takeEvery(GESTION_OPERATIVA_SELECT_STOCK, calculateRemainingSaga);
    yield takeEvery(GESTION_OPERATIVA_RETRY_OFFER_BEGIN, retryOfferDMSSaga);
    yield takeEvery(GESTION_OPERATIVA_RE_ENTERED_VEHICLE_BEGIN, reEnteredVehicleSaga);
}